<glxy-form-field id="currency" [size]="'small'" [prefixText]="currencyCode" [bottomSpacing]="false">
  <glxy-label *ngIf="label">{{ label | translate }}</glxy-label>
  <input matInput (keydown)="key($event)" (keyup)="key($event)" #input [id]="id" />
  <automata-automation-variable-menu
    *ngIf="showVariableItemMenu"
    matSuffix
    useGalaxyCompat="true"
    [dontIncludeDefaultCategories]="true"
    [supportedDataTypes]="supportedDataTypes"
    (variableSelected)="insertTheVariable(inputControl, $event)"
  ></automata-automation-variable-menu>
</glxy-form-field>
